import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../contexts/HeaderContext";
import {
  Container,
  ContentWrapper,
  LeftSection,
  LeftFrame,
  ContactUsHeading,
  TitleSection,
  SubTitle,
  Description,
} from "./styles";

// 추가 스타일 컴포넌트
import styled from 'styled-components';

const HomeButton = styled.button`
  width: 200px;
  min-width: 130px;
  padding: 16px 30px;
  background: #FF4F00;
  border-radius: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: none;
  cursor: pointer;
  margin-top: 90px;
  margin-bottom: 11px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #E64800;
  }
  
  @media (max-width: 768px) {
    width: calc(100% - 40px);
    margin: 0;
    position: absolute;
    bottom: 60px;
    left: 20px;
    right: 20px;
  }
`;

const HomeButtonText = styled.div`
  color: white;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 28px;
`;

const MobileHiddenHeading = styled(ContactUsHeading)`
  @media (max-width: 768px) {
    display: none;
  }
`;

const NoBreakDescription = styled(Description)`
  @media (max-width: 768px) {
    br {
      display: none;
    }
    word-break: keep-all;
  }
`;

const ResultContentWrapper = styled(ContentWrapper)`
  padding-top: 140px;
  padding-bottom: 0;
  height: auto;
  
  @media (max-width: 768px) {
    padding-top: 110px;
    padding-bottom: 0;
    position: static;
    flex: 1;
  }
`;

const MobileTitleSection = styled(TitleSection)`
  @media (max-width: 768px) {
    gap: 40px;
  }
`;

const ResultContainer = styled(Container)`
  min-height: unset;
  height: 795px;
  
  @media (max-width: 768px) {
    height: auto;
    min-height: calc(100vh - 221px); /* 100vh - footer height */
    position: relative;
    padding-bottom: 60px; /* button height(60px) + bottom spacing(60px) + extra padding(20px) */
    display: flex;
    flex-direction: column;
  }
`;

const ResultLeftSection = styled(LeftSection)`
  min-height: unset;
  height: auto;
  
  @media (max-width: 768px) {
    position: static;
    flex: 1;
  }
`;

const ResultLeftFrame = styled(LeftFrame)`
  height: auto;
  
  @media (max-width: 768px) {
    position: static;
    flex: 1;
  }
`;

const ContactResult = () => {
  const navigate = useNavigate();
  const { setIsTransparent } = useHeader();
  
  // Set header to non-transparent (default header)
  useEffect(() => {
    setIsTransparent(false);
    return () => {
      // Cleanup when component unmounts
      setIsTransparent(false);
    };
  }, [setIsTransparent]);

  const handleHomeClick = () => {
    navigate('/'); // 홈으로 이동
    window.scrollTo(0, 0);
  };

  return (
    <ResultContainer>
      <ResultLeftSection>
        <ResultContentWrapper>
          <ResultLeftFrame>
            <MobileHiddenHeading>Contact us</MobileHiddenHeading>
            <MobileTitleSection>
              <SubTitle>문의가 정상적으로 접수되었습니다.</SubTitle>
              <NoBreakDescription>
                문의 주신 내용은 담당자가 확인 후 빠른 시간 내에 답변드리겠습니다. <br/>문의에 대한 답변은 등록해 주신 이메일로 발송되오니, 메일로 확인해 주세요!
              </NoBreakDescription>
            </MobileTitleSection>
            <HomeButton onClick={handleHomeClick}>
              <HomeButtonText>홈으로 이동</HomeButtonText>
            </HomeButton>
          </ResultLeftFrame>
        </ResultContentWrapper>
      </ResultLeftSection>
    </ResultContainer>
  );
};

export default ContactResult;
